<script>
  import { scale } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import config from "../../stores/config";

  export let flux = [];
  export let show = false;
  export let title = "";
  export let avg;

  const dispatch = createEventDispatcher();

  const onClose = () => {
    dispatch("modalClose");
  };
</script>

{#if show}
  <div
    on:click|self={onClose}
    class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/50"
    style="z-index: 999;"
  >
    <div
      transition:scale
      class="w-4/12 h-5/6 bg-gray-50 rounded-lg shadow-2xl py-4 px-5 border-t-2 border-brand overflow-auto"
    >
      <!-- Window title -->
      <div class="flex justify-between mb-4">
        <div class="flex items-center">
          <i class="fas fa-chart-line mr-2 text-xl" />
          <div class="uppercase text-base flex items-center">
            {title} : price flux
          </div>
        </div>
        <div class="flex items-center justify-center">
          <button class="btn btn-primary" on:click={onClose}>
            <i class="fas fa-times-circle" />
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="">
        <div class="">
          <div
            class="flex items-center uppercase text-brand pb-1 border-b border-brand"
          >
            Average : R{avg}
          </div>

          {#each flux.reverse() as f}
            <div
              in:fade={{ duration: $config.f.time() }}
              class="tr border-b border-gray-100 flex items-center py-2 text-sm text-gray-500"
            >
              <div
                style="min-width: 15rem; max-width: 15rem;"
                class="flex items-center"
              >
                <i class="fas fa-clock mr-2 text-sm" />
                {new Date(`20${f.d}`).toDateString()}
              </div>
              <div style="min-width: 7rem; max-width: 7rem;">R{f.p}</div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
{/if}
